import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userInfo: JSON.parse(localStorage.getItem('USER')) || {},
    isErr: 1
  },
  mutations: {
    getUserInfo(state, data) {
      state.userInfo = data;
      localStorage.setItem('USER', JSON.stringify(data))
    },
    errRequest(state, data) {
      state.isErr = data;
    }
  },
  actions: {
    getUserInfo(context, data) {
      context.commit('getUserInfo', data)
    },
    errRequest(context, data) {
      context.commit('errRequest', data)
    }
  },
  getters: {
    userInfo(state) {
      return state.userInfo
    },
  }
})


// WEBPACK FOOTER //
// ./src/store/index.js